export default __webpack_public_path__ + "static/media/CancelAppDisabled.9a926277.svg";